import { createSlice } from "@reduxjs/toolkit";
import { sessionEnded } from "./authSlice";

// Requests suspended while the "contact support" dialog is open. Kept out of
// Redux: promise callbacks are not serializable and must never be persisted.
const pendingRequests = new Set();

export const LOCK_CODES = ["ACCOUNT_LOCKED", "MAX_LOGIN_ATTEMPTS", "MAX_2FA_ATTEMPTS"];

const REASONS = {
  ACCOUNT_LOCKED:
    "Your account has been locked after too many failed sign-in or verification attempts.",
  MAX_LOGIN_ATTEMPTS: "Your account has been locked after too many failed sign-in attempts.",
  MAX_2FA_ATTEMPTS:
    "Your account has been locked after too many failed identity verification attempts."
};

const slice = createSlice({
  name: "supportPrompt",
  initialState: { show: false, code: null, reason: "", support: null },
  reducers: {
    needSupport: (s, a) => {
      const code = a.payload?.code || "ACCOUNT_LOCKED";
      s.show = true;
      s.code = code;
      s.reason = REASONS[code] || REASONS.ACCOUNT_LOCKED;
      s.support = a.payload?.support || null;
    },
    closeSupport: (s) => {
      // Keep code/reason so the text doesn't blank out during the exit
      // transition; the next needSupport overwrites them.
      s.show = false;
    }
  }
});

export const { needSupport, closeSupport } = slice.actions;

/** Called by fetchWithAuth: park the request's reject until the dialog closes. */
export function suspendForSupport(reject) {
  pendingRequests.add(reject);
}

/**
 * Close the dialog and settle every suspended request with ACCOUNT_LOCKED.
 * A locked account's session is over (MTO 1.12): forget the user too.
 */
export const dismissSupport = () => (dispatch, getState) => {
  const rejects = [...pendingRequests];
  pendingRequests.clear();
  rejects.forEach((reject) => reject(new Error("ACCOUNT_LOCKED")));
  dispatch(closeSupport());
  if (getState().auth?.user) dispatch(sessionEnded({ code: "ACCOUNT_LOCKED" }));
};

export const __pendingSupportRequests = pendingRequests;
export default slice.reducer;
